/**
 * @generated SignedSource<<8867f77775c8623d311ef253cb68de13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type createSamlIdentityProviderMutation$variables = {
  connections: ReadonlyArray<string>;
  metadataFile?: string | null;
  metadataUrl?: string | null;
  name: string;
  organizationNodeId: string;
  uuid?: any | null;
};
export type createSamlIdentityProviderMutation$data = {
  readonly createSamlIdentityProvider: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly identityProviderConfiguration: {
      readonly id: string;
      readonly name: string;
      readonly providerType: identityprovidertype;
      readonly samlAcsUrl: string | null;
      readonly samlMetadataUrl: string | null;
      readonly uuid: string;
    } | null;
  } | null;
};
export type createSamlIdentityProviderMutation = {
  response: createSamlIdentityProviderMutation$data;
  variables: createSamlIdentityProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataFile"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataUrl"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationNodeId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v6 = [
  {
    "kind": "Variable",
    "name": "metadataFile",
    "variableName": "metadataFile"
  },
  {
    "kind": "Variable",
    "name": "metadataUrl",
    "variableName": "metadataUrl"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "organizationNodeId",
    "variableName": "organizationNodeId"
  },
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "IdentityProviderConfiguration",
  "kind": "LinkedField",
  "name": "identityProviderConfiguration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "samlAcsUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "samlMetadataUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createSamlIdentityProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "CreateSamlIdentityProvider",
        "kind": "LinkedField",
        "name": "createSamlIdentityProvider",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "createSamlIdentityProviderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "CreateSamlIdentityProvider",
        "kind": "LinkedField",
        "name": "createSamlIdentityProvider",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "identityProviderConfiguration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "IdentityProviderConfigurationEdge"
              }
            ]
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19c0289a1b79e07a1329121c8107ee5c",
    "id": null,
    "metadata": {},
    "name": "createSamlIdentityProviderMutation",
    "operationKind": "mutation",
    "text": "mutation createSamlIdentityProviderMutation(\n  $organizationNodeId: ID!\n  $name: String!\n  $metadataUrl: String\n  $metadataFile: String\n  $uuid: UUID\n) {\n  createSamlIdentityProvider(organizationNodeId: $organizationNodeId, name: $name, metadataUrl: $metadataUrl, metadataFile: $metadataFile, uuid: $uuid) {\n    identityProviderConfiguration {\n      id\n      uuid\n      name\n      providerType\n      samlAcsUrl\n      samlMetadataUrl\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "b21bce4b364aae814bf0b58bc89fb11b";

export default node;
